function isWechatBrowser () {
  let microMessenger = navigator.userAgent.toLowerCase().match(/MicroMessenger/i)
  return microMessenger && microMessenger.toString() === 'micromessenger'
}

function getAuthorizeUrl () {
  let appId = process.env.WX_APP_ID
  let rUrl = window.encodeURIComponent(process.env.WX_AUTH_REDIRECT_URL)
  return `https://open.weixin.qq.com/connect/oauth2/authorize?appid=${appId}&` +
    `redirect_uri=${rUrl}&response_type=code&scope=snsapi_base&state=123#wechat_redirect`
}

export {
  isWechatBrowser,
  getAuthorizeUrl
}



// WEBPACK FOOTER //
// ./src/utils/wx.js